import LatestOpportunities from '@/components/Table/LatestOpportunities';

function Overview() {
  return (
    <div>
      <div className='border-b border-neutralColor-light pb-5 mb-5'>
        <h3 className='text-3xl font-extrabold m-0'>Overview</h3>
      </div>
      <div className='container grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
        <div className='relative p-5 h-80 bg-white shadow-lg rounded-md'>
          <div className='absolute px-5 text-center'>
            <h3 className='text-gray-500 font-bold'>Market</h3>
          </div>
          {/* <PieChart
            labels={[
              "Chicago",
              "New York",
              "Baltimore",
              "Washington D.C",
              "Other",
            ]}
            datasets={randomDataSetsForTDM(5)}
            chartTitle=""
          /> */}
        </div>
        <div className='relative p-5 h-80 bg-white shadow-lg rounded-md'>
          <div className='absolute px-5 text-center'>
            <h3 className='text-gray-500 font-bold'>Square Feet</h3>
          </div>
          {/* <PieChart
            labels={["Peoplestown", "Dopont", "Woodlawn", "Haris", "Spring"]}
            datasets={randomDataSetsForTDM(5)}
            chartTitle=""
          /> */}
        </div>
        <div className='relative p-5 h-80 bg-white shadow-lg rounded-md'>
          <div className='absolute px-5 text-center'>
            <h3 className='text-gray-500 font-bold'>Project Type</h3>
          </div>
          {/* <PieChart
            labels={[
              "Multi-Family",
              "Hotel",
              "Industrial",
              "Office",
              "Single Family",
            ]}
            datasets={randomDataSetsForTDM(3)}
            chartTitle=""
          /> */}
        </div>
        <div className='relative p-5 h-80 bg-white shadow-lg rounded-md'>
          <div className='absolute px-5 text-center'>
            <h3 className='text-gray-500 font-bold'>Construction Type</h3>
          </div>
          {/* <PieChart
            labels={[
              "Renovation",
              "New Construction",
              "Historic Renovation",
              "Interior Fitout",
            ]}
            datasets={randomDataSetsForTDM(4, 4)}
            chartTitle=""
          /> */}
        </div>
        <div className='relative p-5 h-80 bg-white shadow-lg rounded-md'>
          <div className='absolute px-5 text-center'>
            <h3 className='text-gray-500 font-bold'>Procurement Type</h3>
          </div>
          {/* <PieChart
            labels={["Off-Market", "On-Market", "RFP"]}
            datasets={randomDataSetsForTDM(3, 3)}
            chartTitle=""
          /> */}
        </div>
        <div className='relative p-5 h-80 bg-white shadow-lg rounded-md'>
          <div className='absolute px-5 text-center'>
            <h3 className='text-gray-500 font-bold'>TDC</h3>
          </div>
          {/* <PieChart
            labels={["$49M", "$21M", "$15M", "$10M", "$9M"]}
            datasets={randomDataSetsForTDM(5)}
            chartTitle=""
          /> */}
        </div>
      </div>
      <LatestOpportunities />
    </div>
  );
}

export default Overview;
